import { completeImageUrl } from './imageUrl';

// What is shown for a product that has no photo: the same placeholder on every page.
export const DEFAULT_PRODUCT_IMAGE = 'https://via.placeholder.com/300x300/cccccc/666666?text=No+Image';

// The backend signs every photo URL anew on each response (the X-Amz-Date / signature differ), so the same photo
// arrives under a different URL each time and the browser reloads it: the card "blinks" when its product comes back
// in another response (e.g. the filtered list replacing the full one). The first URL seen for a photo is kept and reused.
const photoUrlCache = new Map();

// First photo of the product (the 600px version when there is one), or the shared default image.
export function getProductImageUrl(product) {
  const firstAttachment = product?.attachments?.[0];
  if (firstAttachment) {
    const url = completeImageUrl(firstAttachment.file.medium?.url) ||
                completeImageUrl(firstAttachment.file.url) ||
                DEFAULT_PRODUCT_IMAGE;
    if (firstAttachment.id == null) return url;
    if (!photoUrlCache.has(firstAttachment.id)) photoUrlCache.set(firstAttachment.id, url);
    return photoUrlCache.get(firstAttachment.id);
  }
  return DEFAULT_PRODUCT_IMAGE;
}
